module.exports = __webpack_public_path__ + "static/media/spc.1ac43d33.png";